module.exports = __webpack_public_path__ + "img/facebook.8256f9c9.svg";